import { FormBase } from "../../util/form-base-form";
import { Roles } from "../../constants/roles";

class BoardCardReviewDetailsFormBase extends FormBase {
    public getToggle(root: ParentNode): HTMLButtonElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_CARD_REVIEW_DETAILS_TOGGLE}"]`, HTMLButtonElement);
    }

    public getBody(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_CARD_REVIEW_DETAILS_BODY}"]`, HTMLElement);
    }

    public getClosestReviewDetails(target: Element | null | undefined): HTMLElement | null {
        return this.closest(target, ".board-card-list__review-details", HTMLElement);
    }
}

const formBase = new BoardCardReviewDetailsFormBase();

export class BoardCardReviewDetailsForm {
    public static getToggle(root: ParentNode): HTMLButtonElement | null {
        return formBase.getToggle(root);
    }

    public static getBody(root: ParentNode): HTMLElement | null {
        return formBase.getBody(root);
    }

    public static getClosestReviewDetails(target: Element | null | undefined): HTMLElement | null {
        return formBase.getClosestReviewDetails(target);
    }
}
